import axios from 'axios'
import { Auth } from 'aws-amplify'
import { v4 as uuidv4 } from 'uuid'
import { AZIMUTH_API_URL } from 'constants/Api.constants'
import { Maybe } from '@vendorflow/types'
import { AUTHORIZATION_SENTINEL } from 'features/auth/Auth.constants'

export default () => {
  axios.interceptors.request.use(async (config) => {
    // make sure we don't send any custom headers and skip the logic below
    if (config.headers?.['noCustomHeaders']) {
      delete config.headers['noCustomHeaders']
      delete config.headers['Authorization']
      delete config.headers['UserId']

      return config
    }
    // requests will set this to true, so that it is intercepted
    // and modified here
    if (config.headers?.['Authorization'] === AUTHORIZATION_SENTINEL) {
      try {
        const session = await Auth.currentSession()
        let authToken: Maybe<string> = null

        if (config.url) {
          if (config.url.includes(AZIMUTH_API_URL)) {
            authToken = session.getAccessToken().getJwtToken()
          } else {
            authToken = session.getIdToken().getJwtToken()
          }
        }

        if (authToken) {
          config.headers['Authorization'] = `Bearer ${authToken}`
        }
      } catch (e) {}
    }

    // @ts-ignore
    if (config.headers?.['UserId'] === true) {
      try {
        const info = await Auth.currentUserInfo()

        if (info) {
          config.headers['UserId'] = info.id
        }
      } catch (e) {}
    }

    if (config.url?.includes('vendorflow.co')) {
      // set a trace and span ID for all requests
      const pieces = uuidv4().split('-')
      const traceAndSpanId = pieces[1] + pieces[4]
      config.headers['x-b3-traceid'] = traceAndSpanId
      config.headers['x-b3-spanid'] = traceAndSpanId

      // also add the commit version
      config.headers['x-vf-spa-version'] = COMMIT_HASH
    }

    return config
  })

  axios.interceptors.response.use(async (response) => {
    // if Azimuth believes we are unauthorized, then we will need to force a logout.
    if (response.config.url?.includes(AZIMUTH_API_URL) && response.status === 401) {
      await Auth.signOut()
      window.location.reload() // we will force a refresh so that the AuthCheckProvider can perform its logout logic
    }

    return response
  })
}
